<app-data-table
    [columns]="columns"
    [data]="tableData"
    [layoutFixed]="false"
>
    <ng-container *cellTemplate="let level of 'departmentCellTemplate'; let departmentKey = dataField">
        <ng-container *ngIf="level.key !== 'total'; else totalTpl">
            <span class="zero-value" *ngIf="(data.Contacts | contactMatrixCount : level.key: departmentKey) == 0">0</span>
            <span class="a" *ngIf="(data.Contacts | contactMatrixCount : level.key: departmentKey) != 0"
                  (click)="viewContacts(level.key, departmentKey)">{{data.Contacts | contactMatrixCount : level.key: departmentKey}}</span>
        </ng-container>

        <ng-template #totalTpl>
            <span class="zero-value" *ngIf="(departmentKey | contactTotal: data.DepartmentTotals) == 0">0</span>
            <span class="a" *ngIf="(departmentKey | contactTotal : data.DepartmentTotals) != 0"
                  (click)="viewDepartmentContacts(departmentKey)">{{(departmentKey | contactTotal : data.DepartmentTotals).toLocaleString()}}</span>
        </ng-template>
    </ng-container>

    <ng-container *cellTemplate="let level of 'totalCellTemplate'">
        <ng-container *ngIf="level.key !== 'total'; else totalTpl">
            <span class="zero-value" *ngIf="(level.key | contactTotal: data.LevelTotals) == 0">0</span>
            <span class="a" *ngIf="(level.key | contactTotal: data.LevelTotals) != 0"
                  (click)="viewLevelContacts(level.key)">{{(level.key | contactTotal: data.LevelTotals).toLocaleString()}}</span>
        </ng-container>

        <ng-template #totalTpl>
            <span class="zero-value" *ngIf="!data.TotalContacts || data.TotalContacts === 0">0</span>
            <span class="a" *ngIf="data.TotalContacts && data.TotalContacts !== 0"
                  (click)="viewAllContacts()">{{data.TotalContacts.toLocaleString()}}</span>
        </ng-template>
    </ng-container>
</app-data-table>
